class FBT {
  constructor() {
    this.button = document.getElementById("add-fbt-product");
    this.buttonSpan = document.querySelector(".count-fbt");
    this.priceWrapper = document.querySelector(".fbt-final-wrapper");
    this.zeroProductMsg = document.querySelector(".fbt-zero-product");
    this.price = document.querySelector(".og-price");
    this.exVatPrice = document.querySelector(".exvat-price");
  }

  getCheckedElements() {
    return Array.from(document.querySelectorAll(".check-btn:checked"));
  }

  formatPrice(price) {
    return price.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
  }

  getPrices(elements) {
    let exVatPrice = elements.reduce(
      (acc, obj) => acc + parseFloat(obj.getAttribute("data_money")),
      0
    );
    let price = elements.reduce(
      (acc, obj) =>
        acc +
        parseFloat(
          this.formatPrice(
            parseFloat(obj.getAttribute("data_money")) +
              parseFloat(obj.getAttribute("data_money")) * 0.2
          )
        ),
      0
    );

    return {
      exVatPrice: exVatPrice.toFixed(2),
      price: price.toFixed(2),
    };
  }

  validateCheckbox() {
    let elements = this.getCheckedElements();
    let count = elements.length;
    let prices = this.getPrices(elements);

    if (count > 1) {
      let text = "all of them ";
      switch (count) {
        case 1:
          text = "";
          break;
        case 2:
          text = "both ";
          break;
        case 3:
          text = "all three ";
          break;
      }
      this.buttonSpan.innerHTML = text;
      this.priceWrapper.classList.remove("hide-fbt");
      this.zeroProductMsg.classList.add("hide-fbt");
    } else {
      this.priceWrapper.classList.add("hide-fbt");
      this.zeroProductMsg.classList.remove("hide-fbt");
    }
    this.price.innerHTML = `£${prices.price}`;
    this.exVatPrice.innerHTML = `£${prices.exVatPrice}`;
  }

  addItemsToCart() {
    let elements = this.getCheckedElements();
    let formData = {
      items: elements.map((item) => ({ id: item.value, quantity: 1 })),
    };

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) =>
        document.dispatchEvent(new CustomEvent("ajaxProduct:added"))
      )
      .catch((error) => console.error("Error:", error));
  }

  init() {
    const checkbox = document.getElementsByClassName("check-btn");
    Array.from(checkbox).forEach((element) =>
      element.addEventListener("change", this.validateCheckbox.bind(this))
    );
    this.validateCheckbox();
    this.button.addEventListener("click", this.addItemsToCart.bind(this));
  }
}

window.addEventListener("load", function () {
  new FBT().init();
});
